const partyCardStyles = {
  center: {
    display: "flex",
    alignItems: "center",
    height: "100%"
  },
  centerProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  },
  descriptionText: {
    overflowY : "auto",
    maxHeight: "12vh"
  },
  start: {
    opacity: "0",
    marginTop: "-10%"
  },
  end: {
    transition: "1s",
    opacity: "1"
  }
};

export default partyCardStyles;
